export enum LogoutActionDispatchTypes {
  LOGOUT_ERROR = "LOGOUT_ERROR",
  LOGOUT_INVOKE = "LOGOUT_INVOKE",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
}